import { CriteriaPanelistsManagerReadModel } from "@Evaluation/CriteriaSurveys/Domain/readmodels";

export class CriteriaPanelistsManagerViewModel
{
    opened: boolean = false;
    workspaceId: number;
    projectId: number;

    data: CriteriaPanelistsManagerReadModel | null = null;

    constructor(workspaceId: number, projectId: number)
    {
        this.workspaceId = workspaceId;
        this.projectId = projectId;
    }

    show()
    {
        this.data = null;

        this.opened = true;
    }

    setData(data: CriteriaPanelistsManagerReadModel)
    {
        this.data = data;
    }

    close()
    {
        this.opened = false;

        this.data = null;
    }

}
